<template>
  <div class="config-dialog" :class="`caseId-${caseid}`"  :style="`background-image:url('${data.icon}')`">
    <div @click.stop ="handleButtonClick(data.mainButtonSkip)"  data-sensors-click :class="`caseId-${caseid}`"  class="config-dialog-btn" :style="`color:${data.mainButtonColor}`">{{ data.mainButtonText }}</div>
    <p class="config-dialog-detail" v-if="data.subButtonText"   data-sensors-click :class="`caseId-${caseid}`"  :style="`color:${data.subButtonColor}`" @click.stop ="handleButtonClick(data.subButtonSkip)">{{ data.subButtonText }} ></p>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'
import bg from './d1.png'
export default {
  data () {
    return {
      visible: true,
      bg
    }
  },
  props: {
    caseid: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({
        mainButtonText: '', // 主按钮文案
        mainButtonColor: '', // 主按钮颜色
        mainButtonSkip: '', // 主按钮跳转
        subButtonText: '', // 副按钮文案
        subButtonColor: '', // 副按钮颜色
        subButtonSkip: '' // 副按钮跳转
      })
    },
    isLogin: Boolean
  },
  methods: {
    open () {
      this.visible = true
      setKey('CONFIG_DIALOG_SHOW_TIME', Date.now())
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    /**
     * @param {PROVIDE_DETAIL} 天美贷对应发放详情页 
     * @param {COUPON_LIST} 天美贷我的券包列表 
     * @param {CREDIT_APPLY} 天美贷授信申请 
     * @param {LOAN_APPLY} 天美贷提现申请 
     */
    handleButtonClick (skipType) {
      this.$router.push({
        path: '/middle/coupon',
        query: {
          skipType,
          couponSerialNo: this.data.couponSerialNo
        }
      })
    },
    show () {
      this.isLogin && setKey('CONFIG_DIALOG_SHOW_TIME', Date.now())
    }
  }
}
</script>
<style lang='less' scoped>
@import "../../../../assets/less/mixin.less";

  .config-dialog {
    width:620px;
    height:750px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    &-btn {
      position: absolute;
      top:540px;
      font-size: 36px;
      text-align: center;
      width: 100%;
      left:0;
      height: 80px;
      line-height: 80px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }
    &-detail {
      position: absolute;
      top: 630px;
      font-size: 28px;
      text-align: center;
      width: 100%;
      height: 60px;
      line-height: 60px;
      color: #fff;
    }
  }
</style>